import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  SelectInput,
} from 'react-admin';
import { createUpdateStyle } from '../../style';
import Typography from '@material-ui/core/Typography';
import { CustomToolbar } from '../../components/CustomToolBar';
import * as React from 'react';

/**
 * UsersCreate component for creating new users
 * Similar to DestinationCreate, but uses custom API endpoints
 */
export const UsersCreate = (props) => {
  const classes = createUpdateStyle();

  // Transform data before submitting to API
  // Convert single role to an array with one item
  const transform = (data) => {
    return {
      ...data,
      roles: data.role ? [data.role] : []
    };
  };

  return (
    <div className={classes.card}>
      <a className={classes.breadcrumbLink} href="#/users">
        {'< Users'}
      </a>
      <Create transform={transform} title="Add User" {...props}>
        <SimpleForm redirect="list" toolbar={<CustomToolbar {...props} />}>
          <Typography variant="h6">Add User</Typography>
          <TextInput className={classes.textField} helperText={false} source="email" />
          <TextInput className={classes.textField} helperText={false} source="name" />
          <PasswordInput className={classes.textField} helperText={false} source="password" />
          <SelectInput
            className={classes.textField}
            source="role"
            choices={[
              { id: 'dh-admin', name: 'DH Admin' },
              { id: 'dh-user', name: 'DH User' },
              { id: 'brs-user', name: 'BRS User' },
              { id: 'ar-user', name: 'AR User' },
              { id: 'aviary-admin', name: 'Aviary Admin' }
            ]}
          />
        </SimpleForm>
      </Create>
    </div>
  );
};
